"use client"

import { type FragmentType, graphql, useFragment } from "@/gql"
import React, { FC } from "react"
import { AboutLeftContent } from "./AboutLeftContent"
import { AboutRightContent } from "./AboutRightContent"
import type { NovaSession } from "@/types"
import { PortfolioUIState } from "../page"
import { useEditPortfolio } from "./edit/useEditPortfolio"
import { AboutContentIsProFragmentDoc } from "@/gql/graphql"

const AboutContentFragment = graphql(`
  fragment AboutContent on IndividualCreative {
    id
    __typename
    ...AboutLeftContent
    ...AboutRightContent
  }
`)

graphql(`
  fragment AboutContentIsPro on User {
    id
    creative {
      ...AboutRightContentIsPro
    }
  }
`)

interface Props {
  creative: FragmentType<typeof AboutContentFragment> | null | undefined
  serverSession: NovaSession | null
  uiState: PortfolioUIState
  editProfileMethods?: ReturnType<typeof useEditPortfolio>
  viewerUser: FragmentType<typeof AboutContentIsProFragmentDoc> | null | undefined
}

export const AboutContent: FC<Props> = props => {
  const creative = useFragment(AboutContentFragment, props.creative)
  const viewerUser = useFragment(AboutContentIsProFragmentDoc, props.viewerUser)
  const { serverSession, uiState, editProfileMethods } = props

  return (
    <div className="grid w-full grid-cols-12 md:gap-4">
      <div className="col-span-12 lg:col-span-8">
        <div className="lg:mr-6 xl:mr-10">
          <AboutLeftContent
            creative={creative?.__typename === "IndividualCreative" ? creative : undefined}
            editProfileMethods={editProfileMethods}
            uiState={uiState}
          />
        </div>
      </div>
      <div className="col-span-12 mt-8 lg:col-span-4 lg:mt-0">
        <AboutRightContent
          creative={creative?.__typename === "IndividualCreative" ? creative : undefined}
          editProfileMethods={editProfileMethods}
          serverSession={serverSession}
          viewerCreative={viewerUser?.creative}
        />
      </div>
    </div>
  )
}
